import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Main section title Widget
 */
@Component({
  selector: 'widget-main-section-title',//for compatibility reasons selector stays the same as in ng1
  templateUrl: './main-section-title-widget.component.html',
  styleUrls: ['./main-section-title-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainSectionTitleWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
 * The widget background color class
 */
  public widgetBackgroundColorClass: string;//Task 15286: Change to Widget line - remove dropdown standard list entries So => no more dropdown

  /**
   * Constructor
   * @param injector
   */
  constructor(injector: Injector) {
    super(injector, 'mainSectionTitle', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.executeWidgetDataLoadedInWidgetClass = true;
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.widgetBackgroundColorClass = 'widget-full-line-title-color-red';

    //Task 15286: Change to Widget line - remove dropdown standard list entries
    //before we loaded dropdown items from ref_l2_mainwidgetlines

    this.page?.widgetDataLoaded(this.widgetConfig?.widgetSettings.id);
  }
}
